import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { EnvironmentService } from './environment-service/environment.service';
import { WindowRefService } from './window-ref/window-ref.service';
import { SessionManagementService } from './session-management-service/session-management.service';
import { ChartGeneratorService } from './chart-generator/chart-generator.service';
import { ActivityChartsComponent } from './activity-charts/activity-charts.component';
import { UserErrorsComponent } from './user-errors/user-errors.component';
import { WebErrorsComponent } from './web-errors/web-errors.component';
import { HistoricChartsComponent } from './historic-charts/historic-charts.component';
import { ServiceBusMetricsComponent } from './service-bus-metrics/service-bus-metrics.component';
import { PullRequestReportsComponent } from './pull-request-reports/pull-request-reports.component';
import { PullRequestCommentsComponent } from 'src/app/pull-request-reports/pull-requests-to-review/pull-request-comments/pull-request-comments.component';
import { SelectVstsUserComponent } from './select-vsts-user/select-vsts-user.component';
import { PullRequestsToReviewComponent } from './pull-request-reports/pull-requests-to-review/pull-requests-to-review.component';
import { SelectVstsRepoComponent } from './select-vsts-repo/select-vsts-repo.component';
import { OldFeatureFlagListComponent } from 'src/app/old-feature-flag-list/old-feature-flag-list.component';
import { OldFeatureFlagChartComponent } from 'src/app/old-feature-flag-chart/old-feature-flag-chart.component';
import { NotificationComponent } from './notification/notification.component';
import { BuildHealthComponent } from './build-health/build-health.component';
import { BuildHealthReportComponent } from './build-health/build-health-report/build-health-report.component';
import { BuildHistoryComponent } from './build-health/build-history/build-history.component';
import { PullRequestMapReportComponent } from './pull-request-reports/pull-request-map-report/pull-request-map-report.component';
import { PickOneComponent } from 'src/app/pick-one/pick-one.component';
import { PullRequestBuildsComponent } from 'src/app/pull-request-reports/pull-request-map-report/pull-request-builds/pull-request-builds.component';
import { ErrorManagementComponent } from 'src/app/error-management/error-management.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BuildWidgetComponent } from './dashboard/build-widget/build-widget.component';
import { ActivityWidgetComponent } from './dashboard/activity-widget/activity-widget.component';
import { FeatureFlagWidgetComponent } from './dashboard/feature-flag-widget/feature-flag-widget.component';
import { MaterialModule } from './material/material.module';
import { AuthTokenInterceptor } from './interceptors/auth-token-interceptor';
import { NotFoundComponent } from './not-found/not-found.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { AdalRoleGuard } from 'src/app/adal.role.guard';
import { LoginComponent } from './login/login.component';
import { AdalService } from 'adal-angular4';
import { FeatureFlagDetailsComponent } from './dashboard/feature-flag-widget/feature-flag-details/feature-flag-details.component';
import { AgentCapabilitiesComponent } from './agent-capabilities/agent-capabilities.component';
import { AgentCapabilitiesDetailsComponent } from './agent-capabilities/agent-capabilities-details/agent-capabilities-details.component';

@NgModule({
  declarations: [
    AppComponent,
    ActivityChartsComponent,
    UserErrorsComponent,
    WebErrorsComponent,
    HistoricChartsComponent,
    ServiceBusMetricsComponent,
    PullRequestReportsComponent,
    PullRequestCommentsComponent,
    SelectVstsUserComponent,
    PullRequestsToReviewComponent,
    SelectVstsRepoComponent,
    OldFeatureFlagListComponent,
    OldFeatureFlagChartComponent,
    NotificationComponent,
    BuildHealthComponent,
    BuildHealthReportComponent,
    BuildHistoryComponent,
    PullRequestMapReportComponent,
    PickOneComponent,
    PullRequestBuildsComponent,
    ErrorManagementComponent,
    DashboardComponent,
    BuildWidgetComponent,
    ActivityWidgetComponent,
    FeatureFlagWidgetComponent,
    NotFoundComponent,
    ToolbarComponent,
    LoginComponent,
    FeatureFlagDetailsComponent,
    AgentCapabilitiesComponent,
    AgentCapabilitiesDetailsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    ReactiveFormsModule
  ],
  entryComponents: [
    FeatureFlagDetailsComponent,
    PullRequestCommentsComponent,
    PullRequestBuildsComponent,
    NotificationComponent,
    AgentCapabilitiesDetailsComponent
  ],
  providers: [
    EnvironmentService,
    WindowRefService,
    SessionManagementService,
    ChartGeneratorService,
    AdalService, AdalRoleGuard, 
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: AuthTokenInterceptor, 
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
